import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';
import Signin from '../components/Signin/Signin';

const SigninPage: FC = () => {
  useTitle('Plan NNY | Signin');
  return <Signin />;
};

export default SigninPage;
